/**
 * @generated SignedSource<<f576c6cfc1e854f6c69081efb64df9f8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type guardsMeQuery$variables = Record<PropertyKey, never>;
export type guardsMeQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
        readonly id: string;
      } | null | undefined;
      readonly displayName: string;
      readonly id: string;
      readonly interfaceLocale: string;
      readonly picture: {
        readonly preset: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type guardsMeQuery = {
  response: guardsMeQuery$data;
  variables: guardsMeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interfaceLocale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerPicture",
            "kind": "LinkedField",
            "name": "picture",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Character",
            "kind": "LinkedField",
            "name": "defaultCharacter",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audience",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "guardsMeQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "guardsMeQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "2abb669f6bba052adf3c550963e5c7bb",
    "id": null,
    "metadata": {},
    "name": "guardsMeQuery",
    "operationKind": "query",
    "text": "query guardsMeQuery {\n  me {\n    learner {\n      id\n      displayName\n      interfaceLocale\n      picture {\n        preset\n        url\n      }\n      defaultCharacter {\n        id\n        audience\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2bcd20423c11e1e52008429788b744d8";

export default node;
